module.exports = __webpack_public_path__ + "img/amir.b19c72e8.jpeg";